export default "__VITE_ASSET__mmNYj6zz__"